import { ErrorResponse } from 'react-router-dom';
import { Environment } from '../../../environment';
import { Api} from '../axioscadastro';


import { v4 as uuidv4 } from 'uuid';


export interface IListagemClientes {
   idcli: string,
   nome: string,
   cpf: string,
   fantasia: string,
  
}
export interface  IitensFabricaDialog{
  idclifab: string;
  nome: string;
  percentual:number;

}

interface IDetalheClientes {
  idcli: string;
  nome: string;
  cpf: string;
  fantasia: string;
  rg: string;
  telefone: string;
  celular: string;
  endereco: string;
  numero: string;
  bairro: string;
  cep: string;
  email: string;
  municipio: string;
  fabricas: IitensFabricaDialog[];
}
interface IDetalheCreateClinte {
  nome: string;
  cpf: string;
  fantasia: string;
  rg: string;
  telefone: string;
  celular: string;
  endereco: string;
  numero: string;
  bairro: string;
  cep: string;
  email: string;
  municipio: string;
  
}

type TotalCount = {
    data: IListagemClientes[];
    totalCount: number;
}

const getAll = async (page = 1, filter = ""): Promise<TotalCount | Error> => {
  try {

    const urlRelativa = `/clientes?page=${page}&limit=${14}&filter=${filter}`;

    const { data, headers } = await Api.get(urlRelativa);

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 14),
      };
    }
 
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (id: string): Promise<IDetalheClientes | Error> => {
  try {

    const { data } = await Api.get(`/clientes/${id}`);

    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};


const create = async (dados: IDetalheCreateClinte): Promise<string | Error> => {
  try {
    const guuid = uuidv4();

    const { data } = await Api.post<IDetalheClientes>('/clientes',  {idcli: guuid, ...dados});
  
    if (Object.keys(data).length === 0) {
      return guuid;
    }

    return new Error('Erro ao criar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};


const updateById = async (id: string, dados:IDetalheCreateClinte): Promise<void | Error> => {
  try {
    
    const dadosSaida = { idcli: id, ...dados }; 
    await Api.put(`/clientes/${id}`, dadosSaida);
 } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
 }
};
const updateByIdItens = async (id: string, dados: IitensFabricaDialog): Promise<void | Error> => {
  try {
    const { nome, ...dadosItens } = dados;
    await Api.put(`/clientesfabrica/${id}`, dadosItens);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/clientes/${id}`);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

const getAllList = async (id = '', filter = ''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa: string = id === '' ?  `/clientes?limit=${Environment.LIMITE_DE_LINHAS}&tipo=nome&filter=${filter}` : `/clienteslist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
export const ClientesService = {
  getAll,
  create,
  updateByIdItens,
  getById,
  updateById,
  deleteById,
  getAllList,
};